// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1XvmW","balanceDisclaimer":"posDashboard_balanceDisclaimer__3a3yC"};